module.exports = __webpack_public_path__ + "img/apple-pay.6afa4f1e.svg";